import request from '@/utils/request'

export function getBreakfastCodeListApi(query) {
  return request({
    url: '/config-service/v1/breakfast-code',
    method: 'get',
    params: query
  })
}

export function addBreakfastCodeApi(payload) {
  return request({
    url: '/config-service/v1/breakfast-code',
    method: 'post',
    data: payload
  })
}

export function updateBreakfastCodeApi(payload) {
  return request({
    url: '/config-service/v1/breakfast-code',
    method: 'put',
    data: payload
  })
}

export function deleteBreakfastCodeApi(payload) {
  return request({
    url: '/config-service/v1/breakfast-code',
    method: 'delete',
    data: payload
  })
}

export function getDetailBreakfastCodeApi(params) {
  return request({
    url: `/config-service/v1/breakfast-code/${params.id}`,
    method: 'get'
  })
}
